export default {
	users: (state) => {
		if (state.codes && state.codes.length > 0) {
			let users = []
			state.codes.map(code => {
				if (code.users) users = users.concat(code.users)
			})
			return users
		}
		return []
	}
}
